require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2005-04-10-gpl-libraries-suck.json") })
        }
      }, "path---articles-2005-04-10-gpl-libraries-suck");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2005-04-10-gpl-libraries-suck!./.cache/json/articles-2005-04-10-gpl-libraries-suck.json
// module id = 395
// module chunks = 231608221292675